module.exports = __webpack_public_path__ + "img/logout.ec1a060c.svg";